


























































































































































































import Vue from 'vue';
import InlineSvg from 'vue-inline-svg';
import OrganHeart from '@/components/organs/OrganHeart.vue';
import OrganKidneys from '@/components/organs/OrganKidneys.vue';
import OrganStomach from '@/components/organs/OrganStomach.vue';
import OrganLivers from '@/components/organs/OrganLivers.vue';
import OrganLungs from '@/components/organs/OrganLungs.vue';
import OrganIntestineSmall from '@/components/organs/OrganIntestineSmall.vue';
import OrganIntestineLarge from '@/components/organs/OrganIntestineLarge.vue';

export default Vue.extend<any, any, any, any>({
	// eslint-disable-next-line vue/no-unused-components
	components: {
		OrganKidneys,
		OrganHeart,
		OrganStomach,
		OrganLivers,
		OrganLungs,
		OrganIntestineSmall,
		OrganIntestineLarge,
		InlineSvg,
	},
	props: {
		// Toggle the drag functionality on/off.
		draggable: {
			type: Boolean,
			default: false,
		},
		// List of organs that have been dropped.
		drops: {
			type: Object,
			default: () => ({}),
		},
		// Toggle to show the body dissected (-> empty)
		dissected: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		activeOrgan: '', // Active organ to display tooltip with
		draggedOrgan: '', // Currently dragged organ
		isDragging: false, // Are we performing dragging.
	}),
	methods: {
		showTooltip(organ: string) {
			if (this.activeOrgan === organ) {
				this.activeOrgan = '';
			} else {
				this.activeOrgan = organ;
			}
		},
		mouseDown(organ: string) {
			this.draggedOrgan = organ;
		},
		onTouchStart(organ: string) {
			this.isDragging = true;
			this.draggedOrgan = organ;
			this.$emit('touchstart', organ);
		},
		onTouchEnd() {
			this.dragEnd();
		},
		drag(_event: DragEvent) {
			this.$emit('drag', this.draggedOrgan);
			this.isDragging = true;
		},
		dragStart(event: DragEvent) {
			if (this.$refs[this.draggedOrgan] === undefined) {
				event.preventDefault();
				return;
			}

			this.$emit('dragstart', this.draggedOrgan);
			const { clientWidth, clientHeight } = this.$refs[this.draggedOrgan];
            event.dataTransfer?.setDragImage(this.$refs[this.draggedOrgan], clientWidth / 2, clientHeight / 2);
		},
		dragEnd(event: DragEvent) {
			this.$emit('dragend', this.draggedOrgan);
			this.isDragging = false;
			this.draggedOrgan = '';
		},
	},
});
